import { Alert, Box, Chip, Divider, Grid2, Paper, Typography } from '@mui/material';
import React, { FC, useMemo } from 'react';
import * as Yup from 'yup';
import { format, isValid, parseISO } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { Button } from '../../../Components/Form/Button/button.scomponent';
import { Input } from '../../../Components/Form/Input/input.component';
import { Loader } from '../../../Components/Loader';
import { BaseContentPage } from '../../../Components/Templates/BaseContentPage/base-content-page.componen';
import { BaseScreen } from '../../../Components/Templates/BaseScreen/basescreen.component';
import { CreateArtsUseCase } from '../../../Usecase/Arts/create-arts-usecase';
import { ShowArtsUseCase } from '../../../Usecase/Arts/show-arts-usecase';
import { useCreateReplacementOrder } from './replacement-order-create.hook';
import SelectCustomerVariant from '../../../Components/Modals/variants/select-customer/select-customer-variant.component';
import { ListCustomersUseCase } from '../../../Usecase/Customers/list-customers-usecase';
import SelectProductVariant from '../../../Components/Modals/variants/select-product/select-product-variant.component';
import { ListProductUseCase } from '../../../Usecase/Products/list-product-usecase';
import { Flex } from '../../../Components/Flex/flex.component';
import { Environment } from '../../../Config/constants';
import { ActionButtons } from '../../../Components/Form/ActionButtons/action-buttons.component';
import { Placeholder } from '../../../Components/Placeholder/placeholder.component';
import { Table } from '../../../Components/Table/table.component';
import SelectProductArtVariant from '../../../Components/Modals/variants/select-product-art/select-product-art-variant.component';
import { ListArtsByCustomerUseCase } from '../../../Usecase/Arts/list-by-cusomter-usecase';
import { PDFPreview } from '../../../Components/PDFPreview/pdf-preview.component';
import { CreateOrdersReplacementUseCase } from '../../../Usecase/OrdersReplacement/create-orders-replacement-usecase';
import { ConfirmDialog } from '../../../Components/Dialog/variants/dialog-confirmation/dialog-confirmation.component';
import { ButtonActionMenu } from '../../../Components/Form/ButtonActionsMenu/button-action-menu.component';
import DeleteIcon from '@mui/icons-material/Delete';
import { ShowOrdersReplacementUseCase } from '../../../Usecase/OrdersReplacement/show-orders-replacement-usecase';
import { useParams } from 'react-router-dom';
import { UpdateOrdersReplacementUseCase } from '../../../Usecase/OrdersReplacement/update-orders-replacement-usecase';
import { Can } from '../../../Components/Can';
import { SelectComponent } from '../../../Components/Form/Select/select.component';
import { brandMockOptions, storeTypeOptions } from '../../../Config/shared';
import TextArea from '../../../Components/Form/Textarea/textarea.component';
import InputCalendar from '../../../Components/Form/InputCalendar/input-calendar.component';
import { GetMaskProductOptionsUseCase } from '../../../Usecase/Products/get-mask-product-options-usecase';

  
const SignInSchemaValidation = Yup.object().shape({
    name: Yup.string().required('Nome é obrigatório'),
    code: Yup.string(),
    ncm: Yup.string(),
    personalized: Yup.boolean(),
    createOnNuvemShop: Yup.boolean(),
    createOnOmie: Yup.boolean(),
    price: Yup.string().required('Preço Unitário é obrigatório'),
    description: Yup.string(),
    createOnb2b: Yup.boolean(),
    createOnb2c: Yup.boolean(),
  });

const HCP_FLOW_LABELS: Record<string, string> = {
  AWAITING_ART: 'Arte',
  SHEET: 'Cartela',
  PRODUCTION: 'Produção',
  MACHINE_PRODUCTION: 'Produção de Máquinas',
  LOGISTICS: 'Logística',
}

function getHCPFlowLabel(flow?: string | null): string {
  if (!flow) return 'Não iniciado'
  return HCP_FLOW_LABELS[flow] ?? flow
}

function formatHCPDate(value?: string | null): string {
  if (!value) return '—'
  const date = parseISO(value)
  if (!isValid(date)) return value
  return format(date, 'dd/MM/yyyy HH:mm', { locale: ptBR })
}

function getHCPFinishedLabel(value?: boolean | null): string {
  if (value === true) return 'Finalizado'
  if (value === false) return 'Em aberto'
  return 'Não informado'
}

  interface IOrdersReplacementFormProps {
  
    listCustomersUseCase: ListCustomersUseCase
    listProductsUseCase: ListProductUseCase
    createOrdersReplacementUseCase: CreateOrdersReplacementUseCase
    showOrdersReplacementUseCase: ShowOrdersReplacementUseCase
    updateOrdersReplacementUseCase: UpdateOrdersReplacementUseCase
    getMaskProductOptionsUseCase: GetMaskProductOptionsUseCase
    // updateArtsUseCase: UpdateArtsUseCase
  }
const OrdersReplacementForm : FC<IOrdersReplacementFormProps> = ({  listCustomersUseCase, listProductsUseCase, createOrdersReplacementUseCase, showOrdersReplacementUseCase, updateOrdersReplacementUseCase, getMaskProductOptionsUseCase  }) => {
  const params = useParams();

    const {handleAction, handleSubmit, loading, isDataLoaded, register,setShowBrandsModal, showBrandsModal, errors, data, brandSelected, handleSelectProduct, setShowProductsModal, setIndexSelected, indexSelected,showProductsModal, productsSelected, productsSelectedWithIndex, setProductToDestroy, productToDestroy, handleDestroyProduct, navigate, theme, control, dueDate, setDueDate, maskOptions } = useCreateReplacementOrder({
     
      listCustomersUseCase, listProductsUseCase, createOrdersReplacementUseCase, showOrdersReplacementUseCase, updateOrdersReplacementUseCase, getMaskProductOptionsUseCase
      
    })

 

    const columnsProducts = useMemo(() => {
        const createColumns: any[] = [
        //   {
        //     field: 'photo',
        //     headerName: 'Imagem',
        //     renderCell: (params: any) => <Box component='img' src={params?.row?.images[0]?.link || Environment.IMAGE_PLACEHOLDER} sx={{ width: '80px', height: '80px', objectFit: 'contain'}} />
        //   },
          {
            field: 'name',
            flex: 1,
            headerName: 'Produto',
            renderCell: (params: any) => {
                console.log("parmas: ", params)
                if(!params?.row?.internalName) {
                  return <Flex gap='10px' flexDirection='column' height='100%' alignItems='center' justifyContent='center'>
                    <Typography style={{ color: theme.palette.error.main, fontWeight: 'bold'}}>NOME INTERNO NÃO CADASTRADO. AJUSTAR NO CADASTRO DE PRODUTO</Typography>
                    <Typography style={{ color: theme.palette.error.main}}>Nome amigável: {params?.row?.name}</Typography>
                  </Flex>
                }

                if(params?.row?.internalName) {
                  return <Flex alignItems='center' height='100%'>
               
                    <Typography>{params?.row?.internalName}</Typography>
                  </Flex>
                }
              
            }
          },
         
          {
            field: 'qtd',
            headerName: 'Quantidade',
            flex: 1,
            renderCell: (params: any) => <Flex alignItems='center' height='100%'><Input
                  label="Quantidade"
                  placeholder="Preencha com a quantidade"
                  // error={!!errors.}
                  // helperText={errors.artLink?.message}
                  {...register(`order-qtd-${params.row.id}`)}
              />
            </Flex>
          },
          ...(params.id ? [
            {
              field: 'hcpStatus',
              headerName: 'HCP',
              flex: 1.2,
              renderCell: (params: any) => {
                const hasHCP = Boolean(
                  params.row.hcpCurrentFlow
                  || params.row.hcpCurrentFlowStatusName
                  || params.row.hcpCurrentFlowDisplayCode
                )

                return (
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.75, justifyContent: 'center', height: '100%', width: '100%' }}>
                    <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap' }}>
                      <Chip
                        label={getHCPFlowLabel(params.row.hcpCurrentFlow)}
                        size="small"
                        sx={{
                          height: 22,
                          fontSize: '0.72rem',
                          fontWeight: 700,
                          bgcolor: hasHCP ? 'rgba(21,101,192,0.10)' : 'rgba(0,0,0,0.06)',
                          color: hasHCP ? '#1565c0' : 'text.secondary',
                        }}
                      />
                      {params.row.hcpCurrentFlowDisplayCode && (
                        <Chip
                          label={params.row.hcpCurrentFlowDisplayCode}
                          size="small"
                          sx={{ height: 22, fontSize: '0.72rem', bgcolor: '#eceff3', color: 'text.secondary' }}
                        />
                      )}
                    </Box>
                    <Typography variant="body2" fontWeight={600} title={params.row.hcpCurrentFlowStatusName ?? undefined}>
                      {params.row.hcpCurrentFlowStatusName ?? 'Sem status HCP'}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      {getHCPFinishedLabel(params.row.hcpFinished)}
                    </Typography>
                  </Box>
                )
              }
            },
            {
              field: 'hcpDeadlines',
              headerName: 'Prazos HCP',
              flex: 1.1,
              renderCell: (params: any) => (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, justifyContent: 'center', height: '100%', width: '100%' }}>
                  <Typography variant="caption" color="text.secondary">
                    Início
                  </Typography>
                  <Typography variant="body2" fontWeight={600}>
                    {formatHCPDate(params.row.hcpCurrentFlowStartedAt)}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    Prazo
                  </Typography>
                  <Typography variant="body2" fontWeight={600}>
                    {formatHCPDate(params.row.hcpCurrentFlowDeadline)}
                  </Typography>
                </Box>
              )
            }
          ] : []),
          {
            field: "actions",
            headerName: "Ações",
            headerAlign: "right",
            width: 100,
            // renderCell: (params: any) => <ActionButtons params={params} setItemToDestroy={() => setProductToDestroy(params.row)} editLink={`/products-form/${params.row.id}`} />
            renderCell: (params: any) => <ButtonActionMenu options={[
              {
                title: 'Excluir',
                onClick: () => setProductToDestroy(params.row),
                icon: <DeleteIcon fontSize="small" style={{ marginRight: 1 }} />,
                titleColor: theme.palette.error.main.toString()
              }
            ]} />
          }
        ];
      
        return createColumns;
      }, [productsSelectedWithIndex, params.id, theme]);

    
    return (
      <Can permissions={['menu:replacementOrders:manage']}>
        <BaseScreen>
        <ConfirmDialog title='Remover Produto' onCancel={() => setProductToDestroy(undefined)} description='Você tem certeza?' open={!!productToDestroy} onConfirm={handleDestroyProduct}  /> 
          
        {/* {showBrandsModal && <SelectCustomerVariant data={[]} onClose={() => setShowBrandsModal(false)} onSearch={() => {}} onSelect={handleSelectCustomer} listCustomersUseCase={listCustomersUseCase} />} */}

        {showProductsModal && <SelectProductVariant data={[]} onClose={() => setShowProductsModal(false)} onSearch={() => {}} onSelect={handleSelectProduct} listProductsUseCase={listProductsUseCase} brand={brandSelected?.label} />}

        {/* {showArtsModal?.id && <SelectProductArtVariant data={[]} onClose={() => {
          setShowArtsModal(undefined)
          setIndexSelected(undefined)
        }} onSearch={() => {}} onSelect={handleSelectArt} listProductsUseCase={listProductsUseCase} customerId={String(brandSelected?.id)} productId={showArtsModal.id} listArtsByCustomerUseCase={listArtsByCustomerUseCase} index={indexSelected} />} */}
         
            <Paper >
                <BaseContentPage 
                    title='Pedidos de Reposição'
                    breadcrumb={[{ title: 'Pedidos de Reposição', link: "/orders-replacement-form"}, { title: 'Novo Pedido'}]}
                >

                {!isDataLoaded && params.id && <Loader />}

                {isDataLoaded && (
                  <>
                    {loading && <Loader />}

                    <Grid2 container spacing={5} sx={{ marginTop: 2}} component="form" onSubmit={handleSubmit(handleAction)}>
                  {!params.id && (
                    <Grid2 size={12}>
                      <Alert severity="warning">
                        Produtos sem tipo de produção vinculado não podem ser usados para criar pedido de reposição. Em pedidos de reposição, o fluxo de Logística é ignorado no cálculo/andamento do HCP.
                      </Alert>
                    </Grid2>
                  )}

                  <Grid2 size={6}>
                    <Typography sx={{fontSize: '19px', fontWeight: '600'}}>Loja</Typography>
                      <SelectComponent
                        control={control}
                        name='store'
                        label=''
                        placeholder='Selecione uma loja'
                        options={storeTypeOptions}
                        readOnly={!!params.id}
                        sx={{ 
                          '&:hover': { 
                            cursor: params.id ? 'not-allowed' : 'pointer' 
                          }
                        }}
                      />
                  </Grid2>


              
                  <Grid2 size={6} >
                    <Typography sx={{fontSize: '19px', fontWeight: '600'}}>Marca</Typography>
                      <SelectComponent
                        control={control}
                        name='brand'
                        label=''
                        placeholder='Selecione uma marca'
                        options={maskOptions.brands}
                      />
                
                </Grid2>


                <Grid2 size={6}>
                    <Typography sx={{fontSize: '19px', fontWeight: '600'}}>Data de Entrega</Typography>
                      <InputCalendar 
                        onSubmit={() => {}} 
                        onChange={(e: any) => setDueDate(e)} 
                        defaultValue={dueDate}
                      />
                   
                </Grid2>

                

                {brandSelected?.value && (
                  <Grid2 size={12} mt='50px'>
                      <Flex justifyContent='space-between' alignItems='center'>
                          <Typography sx={{fontSize: '19px', fontWeight: '600'}}>Produtos</Typography>
                          <Button variant='outlined' onClick={() => setShowProductsModal(true)} sx={{ width: '230px' }} isLoading={loading}>Adicionar Produto</Button>
                      </Flex>
                    
                      <Divider sx={{ margin: '10px 0'}} />

                      {productsSelectedWithIndex?.length ?  <Table data={productsSelectedWithIndex} columns={columnsProducts} totalCount={0} pagination={false} isRowSelectable={() => false} disableRowSelectionOnClick={false} /> : <Placeholder description='Nenhum produto adicionado' sx={{ marginTop: '80px'}} />}
                  </Grid2>
                )}

                <Grid2 size={12} mt='50px'>
                <Typography sx={{fontSize: '19px', fontWeight: '600', marginBottom: '15px'}}>Observações</Typography>
                <TextArea
                  label=''
                  placeholder='Preencha com as observações'
                  name="observations"
                  control={control}
                />

                </Grid2>




                <Button type="submit" sx={{  width: '200px' }} isLoading={loading}>
                   {params.id ? 'ATUALIZAR PEDIDO' : 'CRIAR PEDIDO'}
                </Button>
                </Grid2>
                  </>
                )}

              </BaseContentPage>
              
            </Paper>
                
        </BaseScreen>
        </Can>
    )
}

export { OrdersReplacementForm };
